import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextButton from 'LuxKit/Button/TextButton'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import Typography from 'LuxKit/Typography/Typography'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { useAppSelector } from 'hooks/reduxHooks'
import { rem } from 'polished'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import LoyaltyLandingPageLargeTile from './LoyaltyLandingPageLargeTile'
import LoyaltyLandingPageSmallTile from './LoyaltyLandingPageSmallTile'
import useLoyaltyLandingPageBenefitCopy from 'loyalty/hooks/useLoyaltyLandingPageBenefitCopy'
import { EmptyArray } from 'lib/array/arrayUtils'
import Sheet from 'components/utils/Sheet'
import LayoutContainer from 'components/Common/LayoutContainer'

const SmallTilesSection = styled.div`
  display: grid;
  gap: ${rem(24)};

  ${mediaQueryUp.tablet} {
    grid-template-columns: repeat(3, 1fr);
  }
`

interface Props {
  onActivate?: () => void
}

function LoyaltyUserSilverBenefits(props: Props) {
  const { onActivate } = props
  const intl = useIntl()

  const isLoyaltyMember = useAppSelector(state => !!state.loyalty.account.data)

  const [loyaltyLandingPageBenefitTiles] = useLoyaltyLandingPageBenefitCopy()

  const smallTiles = useMemo(() => {
    if (!loyaltyLandingPageBenefitTiles) return EmptyArray
    return [
      loyaltyLandingPageBenefitTiles.phone_support,
      loyaltyLandingPageBenefitTiles.tour_exp_credit,
      loyaltyLandingPageBenefitTiles.discounted_insurance,
    ].filter(tile => tile?.enabled)
  }, [loyaltyLandingPageBenefitTiles])

  return <Sheet background="light-background" padding="24 0" tabletPadding="48 0">
    <LayoutContainer variant="medium">
      <VerticalSpacer gap={48}>
        <VerticalSpacer gap={8}>
          <Heading variant="heading2" align="center">
            {intl.formatMessage({ id: 'i0dUVuRrd4aCX4uM6XHh', defaultMessage: 'Your Silver benefits, ready when you are', description: 'Heading for the silver benefits section on the loyalty landing page' })}
          </Heading>
          {!isLoyaltyMember && <BodyText variant="large" align="center">
            {intl.formatMessage({ id: '-XeV79ck3YOwURIGVzWA', defaultMessage: 'Activate your membership today to get instant access to these benefits', description: 'Body text for the silver benefits section on the loyalty landing page' })}
          </BodyText>}
        </VerticalSpacer>
        {loyaltyLandingPageBenefitTiles?.hotel_upgrade?.enabled && <LoyaltyLandingPageLargeTile
          tile={loyaltyLandingPageBenefitTiles.hotel_upgrade}
          onActivate={onActivate}
        />}
        {loyaltyLandingPageBenefitTiles?.lounge_pass?.enabled && <LoyaltyLandingPageLargeTile
          tile={loyaltyLandingPageBenefitTiles.lounge_pass}
          reverse
        />}
        <SmallTilesSection>
          {smallTiles.map(tile => <LoyaltyLandingPageSmallTile
            key={tile.image.id}
            tile={tile}
          />)}
        </SmallTilesSection>
        {onActivate && <Typography align="center">
          <TextButton kind="primary" onClick={onActivate}>
            {intl.formatMessage({ id: 'h5BA1nDFMI6KI8Q6istS', defaultMessage: 'Activate your free membership', description: 'Button to activate free loyalty membership on the silver benefits section' })}
          </TextButton>
        </Typography>}
      </VerticalSpacer>
    </LayoutContainer>
  </Sheet>
}

export default LoyaltyUserSilverBenefits
